import React from 'react'

import FilterButton from './FilterButton'
import {
  AdultQuantitySelect,
  ChildQuantitySelect,
} from '../common/QuantitySelect'

const getLabelForValue = (value) => {
  if (value > 0) {
    return `${value} ${value > 1 ? 'people' : 'person'}`
  }
  return 'People'
}

class CapacityFilter extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      ...props.values,
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    ;['adults', 'children'].forEach((key) => {
      const newState = {}
      newState[key] = nextProps.values[key] || 0
      this.setState(newState)
    })
  }

  handleFilterChange = (key, value) => {
    const newState = {}
    newState[key] = value
    this.setState(newState)
  }

  onApply = () => {
    const { onChange } = this.props
    onChange(this.state)
  }

  onClear = () => {
    const { onChange } = this.props
    onChange({
      adults: null,
      children: null,
    })
  }

  onReset = () => {
    const { values } = this.props
    ;['adults', 'children'].forEach((key) => {
      const newState = {}
      newState[key] = values[key] || 0
      this.setState(newState)
    })
  }

  render() {
    const { values } = this.props
    const { adults, children } = this.state
    const numberOfPeople = Object.values(this.state).reduce((a, b) => a + b, 0)

    return (
      <FilterButton
        label={getLabelForValue(numberOfPeople)}
        onApply={this.onApply}
        onClear={this.onClear}
        onReset={this.onReset}
        isActive={Object.keys(values).length > 0}
      >
        <AdultQuantitySelect
          value={adults}
          onChange={(count) => this.handleFilterChange('adults', count)}
        />

        <ChildQuantitySelect
          value={children}
          onChange={(count) => this.handleFilterChange('children', count)}
        />
      </FilterButton>
    )
  }
}

export default CapacityFilter
